import { inject } from '@angular/core';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { UserService } from 'app/core/user/user.service';
import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { forkJoin, tap } from 'rxjs';
import { BadgeNotificatonService } from './core/notifications/badge-notification.service';

export const initialDataResolver = () => {
  const navigationService = inject(NavigationService);
  const notificationsService = inject(NotificationsService);
  const quickChatService = inject(QuickChatService);
  const shortcutsService = inject(ShortcutsService);
  const userService = inject(UserService);
  const badgeNotificationService = inject(BadgeNotificatonService);

  // Fork join multiple API endpoint calls to wait all of them to finish
  return forkJoin([
    navigationService.get(),
    notificationsService.getAll(),
    quickChatService.getChats(),
    shortcutsService.getAll(),
    userService.get(),
  ]).pipe(
    tap(() => {
      badgeNotificationService.start();
    }),
  );
};
